class ProgramFaculty {
  constructor(dom) {
    this.NAME = 'ProgramFaculty';
    this.dom = dom;
    this.row = dom.querySelector('[data-faculty-row]');
    this.prev = dom.querySelector('[data-faculty-prev]');
    this.next = dom.querySelector('[data-faculty-next]');
  }

  init() {
    if (!this.row || !this.prev || !this.next) return;

    this.prev.addEventListener('click', () => this.scroll(-1));
    this.next.addEventListener('click', () => this.scroll(1));
  }

  scroll(direction) {
    const card = this.row.querySelector('.program-faculty__card');
    const amount = card ? card.getBoundingClientRect().width + 20 : this.row.clientWidth;
    this.row.scrollBy({ left: direction * amount, behavior: 'smooth' });
  }
}

export default ProgramFaculty;
